import React from "react";
import { Select } from "antd";
const { Option, OptGroup } = Select;

export const CategoryFilter = ({ categories, onChange }) => {
  const handleChange = (value) => {
    onChange(value === "" ? null : value);
  };

  return (
    <Select
      showSearch
      optionFilterProp="label"
      placeholder="Selecciona una infracción"
      style={{ width: 500, marginBottom: 20 }}
      onChange={handleChange}
      allowClear
    >
      <Option key="all" value="" label="Todas las infracciones">
        Todas las infracciones
      </Option>

      {categories.map((parent) => (
        <OptGroup key={parent.id} label={parent.name}>
          {parent.childs.map((child) => (
            <Option
              key={child.id}
              value={child.id}
              label={child.name}
            >
              {child.name}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};
